// extracted by mini-css-extract-plugin
export var card = "card-module--card--8dd78";
export var cardWrap = "card-module--cardWrap--55966";
export var ctaText = "card-module--ctaText--e815a";
export var modalCardIframe = "card-module--modalCardIframe--5a5e0";